export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_17.bec1d356.jpg";